var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('nav-bar'),_c('router-view',{key:_vm.$route.path}),_c('app-footer'),_c('vue-progress-bar'),_c('maker-link')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }